import { Component, OnInit } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseListView } from '../../../../icemedx-lib/src/components/baseview.component';
import { IceNavService } from '../../../../icemedx-lib/src/components/ice-nav/ice-nav.service';
import { IcepanelComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanel.component';
import { IcepanelContainerComponent } from '../../../../icemedx-lib/src/components/icepanel/icepanelcontainer.component';
import { iceColumnDefinition, IcecontrolPermission, IcecontrolSettings, IcemattableSettings, IcepanelcontainerRowSettings, IcepanelcontainerSettings, IcepanelgroupSettings, IcepanelsectionSettings, IcepanelSettings, SECTION_CONTROL_ALIGNMENT } from '../../../../icemedx-lib/src/components/models/icesettings';
import { userTypes } from '../../../../icemedx-lib/src/login/login.config';
import { LoginService } from '../../../../icemedx-lib/src/login/login.service';
import { assetjournal } from '../../../../icemedx-lib/src/models/accounting/assetjournal';
import { chargehistory } from '../../../../icemedx-lib/src/models/accounting/chargehistory';
import { expensejournal } from '../../../../icemedx-lib/src/models/accounting/expensejournal';
import { incomerevenuejournal } from '../../../../icemedx-lib/src/models/accounting/incomerevenuejournal';
import { medicalservice } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservice';
import { medicalserviceindex } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalserviceindex';
import { medicalservicereference } from '../../../../icemedx-lib/src/models/accounting/medservice/medicalservicereference';
import { superbillcharges } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillcharges';
import { superbillchargesindex } from '../../../../icemedx-lib/src/models/accounting/medservice/superbillchargesindex';
import { payment } from '../../../../icemedx-lib/src/models/accounting/payment';
import { superbillindex } from '../../../../icemedx-lib/src/models/accounting/superbillindex';
import { entity } from '../../../../icemedx-lib/src/models/common/entity';
import { IIceEntity } from '../../../../icemedx-lib/src/models/core/IceEntity';
import { subscriber } from '../../../../icemedx-lib/src/models/domain/subscriber';
import { basecodereference } from '../../../../icemedx-lib/src/models/ehr/subs/basecodereference';
import { IceTypes } from '../../../../icemedx-lib/src/models/icetypes';
import { otheritemsindex } from '../../../../icemedx-lib/src/models/otheritems/otheritemsindex';
import { AccountingService } from '../../../../icemedx-lib/src/services/accounting/accounting.service';
import { DomainService } from '../../../../icemedx-lib/src/services/domain/domain.service';
import { Iceutility } from '../../../../icemedx-lib/src/services/iceutility';
import { MessageService } from '../../../../icemedx-lib/src/services/message/message.service';
import { PatientService } from '../../../../icemedx-lib/src/services/patient/patient.service';
import { PayerService } from '../../../../icemedx-lib/src/services/payer/payer.service';
import { PharmacyService } from '../../../../icemedx-lib/src/services/pharmacy/pharmacy.service';
import { ProviderService } from '../../../../icemedx-lib/src/services/provider/provider.service';
import { VendorService } from '../../../../icemedx-lib/src/services/vendor/vendor.service';
import { AppService } from '../app.service';

const ViewByBucket = 1;
const ViewByService = 2;
const ViewByAged = 3;

const viewOptions = "viewOptions";
const domainType = "domainType";
const domainDesc = "domainDesc";
const keywordDesc = "keywordDesc";
const codeDesc = "codeDesc";
const filterButton = "filterButton";

@Component({
  selector: 'app-servicechargehistory',
  templateUrl: './servicechargehistory.component.html',
  styleUrls: ['./servicechargehistory.component.scss'],
  providers: [AppService, IceNavService, IcepanelComponent, IcepanelContainerComponent]
})
export class ServicechargeHistoryComponent extends BaseListView {

  // member settings
  hideAccountingPeriod: boolean = true;

  viewOptions: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: [], width: "200px" }, null, null, viewOptions, "Select Bucket or Single View")
    .setControlName(viewOptions)
    .createFormControl(ViewByBucket, [Validators.required]);

  domainTypeCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: DomainService.getDomainTypes(), width: "100%" }, null, null, domainType, "Type of Service Bucket")
    .setControlName(domainType)
    .createFormControl(IceTypes.ACCOUNT_TYPE.actPatient, []);

  domainCtrl: IcecontrolSettings = new IcecontrolSettings("iceautocomplete", { menuItems: [], width: "200px" }, null, null, domainDesc, "Enter " + DomainService.getDomainType(IceTypes.ACCOUNT_TYPE.actPatient))
    .setMultipleSelection(false)
    .setControlName(domainDesc)
    .createFormControl("", []);

  fromDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "From Date", width: "125px" }, null, null, "FromDate")
    .setControlName("FromDate")
    .createFormControl(null, []);
  toDateCtrl: IcecontrolSettings = new IcecontrolSettings("icedatepicker", { placeholder: "To Date", width: "125px" }, null, null, "ToDate")
    .setControlName("ToDate")
    .createFormControl(null, []);

  keywordCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, keywordDesc, "Keyword")
    .setControlName(keywordDesc)
    .createFormControl("", []);

  codeCtrl: IcecontrolSettings = new IcecontrolSettings("iceinput", { width: "100%" }, null, null, keywordDesc, "Code")
    .setControlName(codeDesc)
    .createFormControl("", []);

  statusCtrl: IcecontrolSettings = new IcecontrolSettings("iceselect", { menuItems: this.getAllStatuses(), width: "100%" }, null, null, "Status", "Status")
    .setControlName("Status")
    .createFormControl(-1, [])
    .setOptions(this.getAllStatuses());

  filterButton: IcecontrolSettings = new IcecontrolSettings("icebutton", { text: "Search", glyphClass: "fas fa-filter", width: "50px" }, null, null, filterButton);

  currentView: number = ViewByService;
  currentCharge: medicalservice = null;
  currentChargeCaption = "Service Charge";
  currentBucket: superbillcharges = null;
  currentBucketChargeList: medicalservice[] = [];
  currentChargeAccountingHistory: any = {};
  currentChargeHistory: chargehistory = new chargehistory(null);

  listOfServices = [];
  listOfInventory = [];
  responsibleParties: any[] = [];
  currentChargePanel: IcepanelSettings = new IcepanelSettings("", "", "", "", []);

  statementsViewSettings: IcepanelcontainerSettings = null;
  statementsPermission: IcecontrolPermission = null;

  breadCrumTitle: string = "Service Charge History";

  constructor(appSvc: AppService,
    navSvc: IceNavService,
    private domainSvc: DomainService,
    private accSvc: AccountingService,
    loginSvc: LoginService,
    router: Router,
    private vendorSvc: VendorService,
    private proSvc: ProviderService,
    private pharmSvc: PharmacyService,
    private payerSvc: PayerService,
    private patSvc: PatientService,
    private activatedRoute: ActivatedRoute) {

    super(appSvc, loginSvc, navSvc, router);

    appSvc.defaultMenus();
    appSvc.addBreadcrumb(this.breadCrumTitle, {}, true, "");

    let feaAccess = appSvc.getPermission(userTypes.USER_FEATURES.ufSuperBill).default_access;
    this.statementsPermission = new IcecontrolPermission(userTypes.USER_FEATURES.ufSuperBill, feaAccess);

    if (feaAccess == userTypes.USER_FEATURE_ACCESS.ufaNone) {
      this.domainSvc.logMessage(IceTypes.LOGTYPE.ltError, "You do not have access to view this data.");
      return;
    }

    this.setInlineEditing(true);
    this.statementsViewSettings = this.viewSetup([], userTypes.USER_FEATURES.ufSuperBill);

    // Default search
    this.activatedRoute.params.subscribe(next => {
      if (next.byType != null) {
        if (next.byType.toLowerCase() == "bybucket")
          this.currentView = ViewByBucket;
        else if (next.byType.toLowerCase() == "byservice")
          this.currentView = ViewByService;

        this.tables[0].iColumns = this.onGetColumnDefinition();
        this.tables[0].actionItems = this.onGetActionItems();
      }

      this.viewOptions.getFormControl().setValue(this.currentView);

      if (next.actType != null && next.actType.length > 0) {
        this.domainTypeCtrl.getFormControl().setValue(Iceutility.toLong(next.actType));
      }

      if (next.act != null && next.act.length > 0) {
        let val = [{ value: next.act, name: next.act }];
        this.domainCtrl.getFormControl().setValue(JSON.stringify(val));
        setTimeout(() => {
          this.domainCtrl.setMultipleSelection(false);
          this.updateNetworkName();
        }, 200)
      }
      else {
        this.updateNetworkName();
      }

      if (this.currentView == ViewByBucket) {
        this.searchBills();
      }
      else {
        if (this.disableSearchButton() == false)
          this.searchServices();
      }
    });
  }

  getBreadcrumbs(): any {
    return this.getAppService().getBreadcrumbs();
  }

  setBreadCrumTitle(title: string): void {
    this.breadCrumTitle = title;
  }

  ngOnInit() {
    this.getAppService().refreshMenus();
  }

  onGetColumnDefinition(): iceColumnDefinition[] {
    if (ViewByBucket == this.currentView) {
      return [
        new iceColumnDefinition("bill_to", "Add Service Bucket", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("to_trans_account_text", "Network ID", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("to_account_type_text", "Type", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("bill_status_text", "Status", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("created", "Created Date", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("modified", "Mod. Date", false, false,
          new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
        new iceColumnDefinition("QuickActions", "", false, false),
        new iceColumnDefinition("superbill_charges_index_key", "superbill_charges_index_key", false, true),
        new iceColumnDefinition("superbill_charges_key", "superbill_charges_key", true),
      ];
    }
    
    return [
      new iceColumnDefinition("service_description", "Service", false, false,
        new IcecontrolSettings("icelabel", { width: "125px" }, null, null)),
      new iceColumnDefinition("date_required", "Date", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("code", "Code", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("trans_account", "Network ID", false, true,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("chargeType", "Type of Charge", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("responsibleParty", "Responsible Party", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("total_amount", "Total", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("amountDue", "Due", false, false,
        new IcecontrolSettings("icelabel", { width: "50px" }, null, null)),
      new iceColumnDefinition("status_text", "Status", false, false,
        new IcecontrolSettings("icelabel", { width: "75px" }, null, null)),
      new iceColumnDefinition("additional_note", "Note", false, false,
        new IcecontrolSettings("icelabel", { width: "100px" }, null, null)),
      new iceColumnDefinition("QuickActions", "", false, false),
      new iceColumnDefinition("medical_service_index_key", "medical_service_index_key", false, true),
      new iceColumnDefinition("medical_service_key", "medical_service_key", true),
    ];
  }

  onGetActionItems(): any[] {
    if (ViewByBucket == this.currentView) {
      return [IceTypes.recordQuickActionViewBucket,
        IceTypes.recordQuickActionViewBalance,
        IceTypes.recordQuickActionRemove];
    }
    return [
      IceTypes.recordQuickActionEdit,
      IceTypes.recordQuickActionViewBucket,
      IceTypes.recordQuickActionViewBalance];
  }

  onGetData(originalData: IIceEntity[]): any[] {
    return originalData;
  }

  getAllStatuses(): any[] {
    let ary = MessageService.getAccountItemStatues();
    ary.push({ value: -1, name: "All" })
    return ary;
  }

  searchBills() {
    this.refreshTableData([]);
    
    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0)
        dom = domObj[0].value;
    }
    catch (e) {
      dom = "";
    }

    let appSvc = this.getAppService();
    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    this.accSvc.getBills(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), "CREATED", status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }

        let bills: superbillchargesindex[] = <superbillchargesindex[]>data;

        let datasrc = [];
        for (let i = 0; i < bills.length; i++) {
          let tempidx: superbillchargesindex = bills[i];
          if (tempidx == null) continue;

          let createdate = Iceutility.isTextDateTime(tempidx.created) ? Iceutility.getDateTextEx(tempidx.created) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.created));
          let modifieddate = Iceutility.isTextDateTime(tempidx.modified) ? Iceutility.getDateTextEx(tempidx.modified) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.modified));
          tempidx.created = createdate;
          tempidx.modified = modifieddate;
          tempidx["to_trans_account_text"] = tempidx.to_trans_account.substr(0, 10);
          tempidx["to_account_type_text"] = DomainService.getDomainType(Iceutility.toLong(tempidx.to_account_type));
          tempidx["bill_status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx.bill_status), IceTypes.SourceType.srcStatement);
          datasrc.push(tempidx);
        }

        this.refreshTableData(data);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  searchServices() {
    this.refreshTableData([]);
    this.currentCharge = null;
    this.currentBucket = null;
    this.currentChargeCaption = "Add Service Charge";
    this.currentBucketChargeList = [];
    this.currentChargeHistory.resetHistoryData();
    this.responsibleParties = [];

    let domType = this.domainTypeCtrl.getFormControl().value;
    let domval = this.domainCtrl.getFormControl().value;
    let fromDt = this.fromDateCtrl.getFormControl().value;
    let toDt = this.toDateCtrl.getFormControl().value;
    let keywd = this.keywordCtrl.getFormControl().value;
    let code = this.codeCtrl.getFormControl().value;
    let status = this.statusCtrl.getFormControl().value;
    let appSvc = this.getAppService();
    let dom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        this.loadResponsibleParties(domType, dom, domObj[0].name);
      }
    }
    catch (e) {
      dom = "";
    }

    let curAct = appSvc.getCurrentAccount();
    let curActType = appSvc.getCurrentAccountType();
    this.accSvc.getServices(curAct, curActType, dom, domType, Iceutility.GetDateText(fromDt, '-', false), Iceutility.GetDateText(toDt, '-', false), keywd, code, status).subscribe(
      data => {
        if (data == null || data.length == 0) {
          this.refreshTableData([]);
          return;
        }
        let svcs: medicalserviceindex[] = <medicalserviceindex[]>data;

        let datasrc = [];
        for (let i = 0; i < svcs.length; i++) {
          let tempidx: medicalserviceindex = svcs[i];
          if (tempidx == null) continue;

          datasrc.push(tempidx);
          this.updateServiceRecord(tempidx, curActType, curAct);
        }

        this.refreshTableData(data);
      }, error => {
        this.refreshTableData([]);
        console.log(JSON.stringify(this.domainSvc.getLastErrors()));
      });
  }

  viewSetup(dat: IIceEntity[], feature: userTypes.USER_FEATURES): IcepanelcontainerSettings {
    let setup: IcepanelcontainerSettings = super.viewSetup(dat, feature);
    if (setup != null) {
      try {
        this.viewOptions.setOptions([
          { name: "Service by Bucket", value: ViewByBucket },
          { name: "List of Services", value: ViewByService }
        ]);
      }
      catch (e) {
        console.log(e);
      }
    }
    return setup;
  }

  disableSearchButton(): boolean {
    if (this.currentView == ViewByService) {
      let domval = this.domainCtrl.getFormControl().value;
      let dom = "";
      try {
        let domObj = JSON.parse(domval);
        if (domObj != null && domObj.length > 0) {
          dom = domObj[0].value;
        }
      }
      catch (e) {
        dom = "";
      }

      return dom == null || dom.length == 0;
    }
    return false;
  }

  updateNetworkName() {
    if (this.statementsViewSettings.rows.length == 0) return;
    if (this.statementsViewSettings.rows[0].columns.length == 0) return;

    let domval = this.domainCtrl.getFormControl().value;
    let dom = "";
    let nameOfDom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        dom = domObj[0].value;
        nameOfDom = domObj[0].name;
      }
    }
    catch (e) {
      dom = "";
      nameOfDom = "";
    }

    if (dom != null && dom.length > 0) {
      this.statementsViewSettings.rows[0].columns[0].title = nameOfDom + " Network ID: #" + dom;
    }
    else {
      if (this.currentView == ViewByBucket) {
        this.statementsViewSettings.rows[0].columns[0].title = "Search All or " + this.domainCtrl.placeholder;
      }
      else {
        this.statementsViewSettings.rows[0].columns[0].title = this.domainCtrl.placeholder;
      }

      this.currentCharge = null;
      this.currentBucket = null;
      this.currentChargeCaption = "Add Service Charge";
      this.currentBucketChargeList = [];
      this.currentChargeHistory.resetHistoryData();
      this.responsibleParties = [];
      this.refreshTableData([]);
    }
  }

  updateServiceRecord(tempidx: medicalserviceindex, domType: IceTypes.ACCOUNT_TYPE, dom: string) {
    if (tempidx == null) return;

    let date_required = Iceutility.isTextDateTime(tempidx.date_required) ? Iceutility.getDateTextEx(tempidx.date_required, null, false) : Iceutility.getDateTextEx(Iceutility.ConvertFromDotNetServerTime(tempidx.date_required), null, false);
    tempidx.date_required = date_required;
    tempidx["chargeType"] = AccountingService.getCoaType(tempidx.inc_coa_type);
    tempidx["status_text"] = MessageService.getStatus(Iceutility.toLong(tempidx.trans_status), IceTypes.SourceType.srcStatement);
    tempidx["amountDue"] = Iceutility.toDouble(tempidx.total_amount);
    setTimeout(() => {
      let respartyKey = AccountingService.getPartyBucketKey(tempidx);
      let foundResP = this.responsibleParties.filter(r => r.value == respartyKey);
      if (foundResP.length > 0) {
        tempidx["responsibleParty"] = foundResP[0].name;
      }
    }, 1000);

    this.currentChargeHistory.setService(tempidx.medical_service_key, {});
    this.currentChargeHistory.setServiceAmountDue(tempidx.medical_service_key, tempidx["amountDue"]);
    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtAsset, IceTypes.coa_types.coaAsset, tempidx.medical_service_key, IceTypes.coa_types.coaDeductibleAR).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceAssets(tempidx.medical_service_key, data);
          this.currentChargeHistory.setAllServicePostings(tempidx.medical_service_key, {});
          let credit = 0.0;
          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
            let jrnl: assetjournal = data[ijrnl];
            let coatyp = Iceutility.toLong(jrnl.coa_type)
            if (coatyp == IceTypes.coa_types.coaAR
              || coatyp == IceTypes.coa_types.coaCoPayAR
              || coatyp == IceTypes.coa_types.coaCoInsuranceAR
              || coatyp == IceTypes.coa_types.coaDeductibleAR) {
              credit += Iceutility.toDouble(jrnl.credit);

              let postingData = this.currentChargeHistory.getServicePosting(tempidx.medical_service_key, jrnl.src_key);
              let srctype = Iceutility.toLong(jrnl.src_type);
              if (srctype == IceTypes.SourceType.srcPayment
                && postingData == null) {
                this.accSvc.getPayment(dom, domType, jrnl.src_key).subscribe(
                  paydata => {
                    if (paydata != null && paydata.length > 0) {
                      if (postingData == null) {
                        this.currentChargeHistory.setServicePosting(tempidx.medical_service_key, jrnl.src_key, paydata[0]);
                      }
                    }
                  },
                  payerror => {
                    console.log(payerror);
                  });
              }
            }
          }
          tempidx["amountDue"] = tempidx["amountDue"] - credit;
          this.currentChargeHistory.setServiceAmountDue(tempidx.medical_service_key, tempidx["amountDue"]);
        }
      },
      error => {
        console.log(error);
      });

    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtExpense, IceTypes.coa_types.coaDiscount, tempidx.medical_service_key, IceTypes.coa_types.coaCorrectionandReversalsAdjustment).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceExpenses(tempidx.medical_service_key, data);
        }
      },
      error => {
        console.log(error);
      });
    this.accSvc.getJournal(dom, domType, "", "", IceTypes.JournalType.jtIncome, IceTypes.coa_types.coaRevenue, tempidx.medical_service_key, IceTypes.coa_types.coaCoInsuranceIncome).subscribe(
      data => {
        if (data != null) {
          this.currentChargeHistory.setServiceIncomes(tempidx.medical_service_key, data);
          let chargeType = IceTypes.coa_types.coaNone;
          for (let ijrnl = 0; ijrnl < data.length; ijrnl++) {
            let jrnl: incomerevenuejournal = data[ijrnl];
            if (chargeType == IceTypes.coa_types.coaNone)
              chargeType = Iceutility.toLong(jrnl.coa_type);
          }
          tempidx["chargeType"] = AccountingService.getCoaType(chargeType);
        }
      },
      error => {
        console.log(error);
      });

  }

  loadResponsibleParties(domType: IceTypes.ACCOUNT_TYPE, dom: string, nameOfDom: string) {
    let appSvc = this.getAppService();
    if (this.responsibleParties.length == 0) {
      let optForBillTo = nameOfDom + " (" + DomainService.getDomainType(domType) + ", Cash Pay)";
      this.responsibleParties = [{ name: optForBillTo, value: "", summary: [] }];
    }
    if (this.responsibleParties.length <= 1) {
      this.patSvc.getPatientSubscribers(dom, appSvc.getCurrentAccount(), appSvc.getCurrentAccountType()).subscribe(
        data => {
          if (data != null && this.responsibleParties.length <= 1) {
            let pyrCovs = null;
            for (let isub = 0; isub < data.length; isub++) {
              let sub: subscriber = data[isub];
              if (sub.COVGS.length > 0) {
                if (pyrCovs == null || pyrCovs.length == 0)
                  pyrCovs = this.patSvc.getPayerCoverageBenefits(sub, true);

                if (pyrCovs != null) {
                  for (let icov = 0; icov < pyrCovs.length; icov++) {
                    let covDtl = pyrCovs[icov];
                    this.responsibleParties.push({
                      name: covDtl["payer_name"] + " (Payer)",
                      value: covDtl["payer_id"],
                      summary: covDtl.summary
                    });
                  }
                }
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }
  }

  loadTemplateServiceAndInventory(domType: IceTypes.ACCOUNT_TYPE) {
    let appSvc = this.getAppService();
    if (this.listOfServices.length == 0) {
      this.accSvc.getBillTemplates(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), domType, "").subscribe(
        billTemplates => {
          if (billTemplates == null || billTemplates.length == 0) {
            return;
          }

          for (let i = 0; i < billTemplates.length; i++) {
            let tempidx: superbillindex = billTemplates[i];
            if (tempidx == null) continue;

            this.accSvc.getBillTemplate(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), tempidx.superbill_key).subscribe(
              superbillData => {
                if (superbillData && superbillData.length > 0) {
                  let superbill = superbillData[0],
                    subtypes = superbill.SUBTYPES;

                  for (var isubtype = 0; isubtype < subtypes.length; isubtype++) {
                    let subtype = subtypes[isubtype];
                    if (subtype == null) continue;

                    let codes = subtype.CODES;
                    for (var icode = 0; icode < codes.length; icode++) {
                      let code: basecodereference = codes[icode];
                      if (code == null) continue;

                      let obj = {
                        value: code.code,
                        name: code.title,
                        code: code.code,
                        price: code.price,
                      };
                      this.listOfServices.push(obj);
                    }
                  }
                }
              },
              error => {
                console.log(JSON.stringify(this.accSvc.getLastErrors()));
              });
          }
        }, error => {
          console.log(JSON.stringify(this.accSvc.getLastErrors()));
        });
    }

    if (this.listOfInventory.length == 0) {
      this.accSvc.getOtherItems(appSvc.getCurrentAccount(), appSvc.getCurrentAccountType(), "*" /*all*/).subscribe(
        data => {
          if (data == null || data.length == 0) {
            return;
          }
          for (let iresult = 0; iresult < data.length; iresult++) {
            let item: otheritemsindex = data[iresult];

            let obj = {
              value: item.item_stock_num,
              name: item.itm_name,
              code: item.item_stock_num,
              price: item.price,
              key: item.other_items_key
            };
            this.listOfInventory.push(obj);
          }
        },
        error => {
          // To do, log error
        });
    }
  }

  showKeyword() {
    return (this.currentView == ViewByService || this.currentView == ViewByAged)
  }

  showCode() {
    return (this.currentView == ViewByService || this.currentView == ViewByAged)
  }

  initializeCurrentChargePanel(event: any) {
    setTimeout(() => {
      if (this.currentChargePanel != null) {
        if (this.currentChargePanel.getInitializeEvent() != null) {
          this.currentChargePanel.getInitializeEvent().emit(event);
        }
      }
    });
  }

  createBucketAndRedirect(curDomType, curDom, svcidx: medicalserviceindex, redirectToBucket: boolean) {
    if (svcidx == null) return;

    if (false == Iceutility.yesnomodal("No Bucket exists for this service. Would you like to create a new bucket? \nOK - To Create or Cancel to skip bucket creation.")) return;
    let chrgRef: medicalservicereference = new medicalservicereference();
    chrgRef.medical_service_reference_key = Iceutility.guid(true);
    chrgRef.medical_service_key = svcidx.medical_service_key;

    let domval = this.domainCtrl.getFormControl().value;
    let nameOfDom = "";
    try {
      let domObj = JSON.parse(domval);
      if (domObj != null && domObj.length > 0) {
        nameOfDom = domObj[0].name;
      }
    }
    catch (e) {
      nameOfDom = "";
    }

    this.currentBucket = new superbillcharges();
    this.currentBucket.from_account_type = curDomType;
    this.currentBucket.from_trans_account = curDom;
    this.currentBucket.to_account_type = svcidx.account_type;
    this.currentBucket.to_trans_account = svcidx.trans_account;
    this.currentBucket.bill_status = IceTypes.trans_status.isNone;
    this.currentBucket.bill_to = nameOfDom;
    this.currentBucket.CHARGES.push(chrgRef);
    this.accSvc.insertBill(curDom, curDomType, this.currentBucket).subscribe(
      data => {
        if (data != null && data.length > 0) {
          let bills: superbillcharges[] = <superbillcharges[]>data;
          this.getRouter().navigate([this.getNavService().buildRoute((redirectToBucket ? "accounting/serviceitemcharge/" : "accounting/outstandingbalance/") + bills[0].superbill_charges_key, false)]);
        }
      },
      error => {
        console.log(error);
      });
  }
  /////////////////////////////////////
  // Events
  onPeriodActionRequired(event) {
    debugger;
    if (event.value == "NoCurrentPeriod")
      this.hideAccountingPeriod = false;
    else
      this.hideAccountingPeriod = true;
  }

  viewOptionsSelectChange(event) {
    this.currentView = event.value;
    this.refreshTableData([]);
    this.tables[0].iColumns = this.onGetColumnDefinition();
    this.tables[0].actionItems = this.onGetActionItems();
    this.updateNetworkName();
  }

  domainSearch(event) {
    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }
    let appSvc = this.getAppService();
    switch (typeOfDomain) {
      case IceTypes.ACCOUNT_TYPE.actPatient: {
        appSvc.setDomainNameList(this.domainCtrl, true, this.domainSvc.getPatientsByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actSubscriber: {
        appSvc.setDomainNameList(this.domainCtrl, true, this.domainSvc.getSubscribersByKeyword(appSvc.getCurrentAccountType(), appSvc.getCurrentAccount(), IceTypes.PatientSearchType.ptSearchKeyword, event["value"]));
        break;
      }
    }
  }

  domainChange(event) {
    if (this.statementsViewSettings.rows.length == 0) return;
    if (this.statementsViewSettings.rows[0].columns.length == 0) return;

    let autoCmp: IcecontrolSettings = <IcecontrolSettings>event.autocompleteSettings;
    if (autoCmp == null) {
      this.statementsViewSettings.rows[0].columns[0].title = "";
    }

    this.updateNetworkName();
  }

  domainTypeSelectChange(event) {
    this.domainCtrl.setOptions([]);

    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }

    this.domainCtrl.placeholder = "Enter " + DomainService.getDomainType(typeOfDomain);
    this.updateNetworkName();
    switch (typeOfDomain) {
      case IceTypes.ACCOUNT_TYPE.actPatient: {
        // Fall through and do lookup upon keyword search        
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actProvider:
      case IceTypes.ACCOUNT_TYPE.actFacility: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.proSvc.getProviders());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPharmacy: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.pharmSvc.getPharmacies());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actVendor: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.vendorSvc.getVendors());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actPayer: {
        this.getAppService().setDomainNameList(this.domainCtrl, true, this.payerSvc.getPayers());
        break;
      }
      case IceTypes.ACCOUNT_TYPE.actSubscriber: {
        // Fall through and do lookup upon keyword search
        break;
      }
      default: {
        // To do error to user
        return;
      }
    }
  }

  filterButtoClick(event) {
    if (this.currentView == ViewByBucket)
      this.searchBills();
    else
      this.searchServices();
  }

  onControlChange(event) {
  }

  onButtonClick(event) {
    if (event.buttonSettings != null) {
      switch (event.buttonSettings.id) {
        case filterButton: {
          break;
        }
      }
    }
  }

  public onAddRowButtonClick(event) {
    if (event.matTableSettings != null) {
      switch (event.matTableSettings.tag) {
        case "Table": {
          let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
          let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
          if (ctrType != null) {
            typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
          }

          let domval = this.domainCtrl.getFormControl().value;
          let dom = "", nameOfDom = "";
          try {
            let domObj = JSON.parse(domval);
            if (domObj != null && domObj.length > 0) {
              dom = domObj[0].value;
              nameOfDom = domObj[0].name;
            }
          }
          catch (e) {
            dom = "";
            nameOfDom = "";
          }
          let nameOfType = DomainService.getDomainType(typeOfDomain);
          if (dom.length == 0 && ViewByService == this.currentView) {
            if (false == Iceutility.yesnomodal("You must enter/select a " + nameOfType + " to add a new service.\nChoose:\nOK - To add a new Service Bucket or\nCancel - To Enter a " + nameOfType))
              return;
            else
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/0", false)]);
          }

          if (ViewByService == this.currentView) {
            this.currentChargeCaption = "Add Service Charge";
            this.loadTemplateServiceAndInventory(typeOfDomain);
            this.loadResponsibleParties(typeOfDomain, dom, nameOfDom);
            this.currentCharge = new medicalservice();
            this.currentCharge.trans_account = dom;
            this.currentCharge.account_type = typeOfDomain;
            this.currentCharge.inc_coa_type = IceTypes.coa_types.coaServiceIncome;
            this.currentBucket = null;
            this.currentBucketChargeList = [];
            this.initializeCurrentChargePanel(event);
          }
          else if (ViewByBucket == this.currentView) {
            if (dom.length == 0)
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/0", false)]);
            else
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemchargebydomain/" + typeOfDomain.toString() + "/" + dom + "/0", false)]);
          }
          break;
        }
      }
    }
  }

  onItemDoneClick(event): void {
    let appSvc = this.getAppService();
    let curDom = appSvc.getCurrentAccount();
    let curDomType = appSvc.getCurrentAccountType();
    if (this.currentCharge.medical_service_key.length == 0) {
      let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
      let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
      if (ctrType != null) {
        typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
      }

      let domval = this.domainCtrl.getFormControl().value;
      let dom = "";
      let nameOfDom = "";
      try {
        let domObj = JSON.parse(domval);
        if (domObj != null && domObj.length > 0) {
          dom = domObj[0].value;
          nameOfDom = domObj[0].name;
        }
      }
      catch (e) {
        dom = "";
        nameOfDom = "";
      }

      this.accSvc.insertServices(curDom, curDomType, this.currentCharge).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let newSvc: medicalservice = data[0];
            let newSvcIdx = new medicalserviceindex().copyservice(newSvc);
            let datasrc = this.getTableData();
            if (datasrc == null || datasrc.length == 0) {
              datasrc = [];
              datasrc.push(newSvcIdx);
            }
            else {
              datasrc.unshift(newSvcIdx);
            }

            this.updateServiceRecord(newSvcIdx, curDomType, curDom);

            this.refreshTableData(datasrc);

            let chrgRef: medicalservicereference = new medicalservicereference();
            chrgRef.medical_service_reference_key = Iceutility.guid(true);
            chrgRef.medical_service_key = newSvc.medical_service_key;

            if (this.currentBucket != null) {
              this.currentBucket.CHARGES.push(chrgRef);
              this.accSvc.updateBill(curDom, curDomType, this.currentBucket).subscribe(
                data => {
                },
                error => {
                  console.log(error);
                });
            }
            else {
              this.currentBucket = new superbillcharges();
              this.currentBucket.from_account_type = curDomType;
              this.currentBucket.from_trans_account = curDom;
              this.currentBucket.to_account_type = typeOfDomain;
              this.currentBucket.to_trans_account = dom;
              this.currentBucket.bill_status = IceTypes.trans_status.isNone;
              this.currentBucket.bill_to = nameOfDom;
              this.currentBucket.CHARGES.push(chrgRef);
              this.accSvc.insertBill(curDom, curDomType, this.currentBucket).subscribe(
                data => {
                },
                error => {
                  console.log(error);
                });
            }
          }
        },
        error => {
          console.log(error);
        });
    }
    else {
      this.accSvc.updateServices(curDom, curDomType, [this.currentCharge]).subscribe(
        data => {
          if (data != null && data.length > 0) {
            let updatedSvc: medicalservice = data[0];
            let datasrc = this.getTableData();
            if (datasrc != null) {
              let foundSvc = datasrc.filter(svc => svc.medical_service_key == updatedSvc.medical_service_key);
              if (foundSvc.length > 0) {
                let postdata = this.currentChargeHistory.getAllServicePostings(updatedSvc.medical_service_key);
                for (const postkey in postdata) {
                  let thispost: payment = postdata[postkey];
                  if (thispost.offline_record_status == IceTypes.offlineRecStatus.offlineInsert) {

                    // To do we need the responsible party information, mostly applies to CC and Check
                    let ent: entity = thispost.ENTS.length > 0 ? thispost.ENTS[0] : null;
                    if (ent == null) {
                      ent = new entity();
                      ent.entity_key = Iceutility.guid(true);
                      thispost.ENTS.push(ent);
                    }

                    thispost.billed_to = ""
                    if (thispost.account_type == IceTypes.ACCOUNT_TYPE.actPatient || thispost.account_type == IceTypes.ACCOUNT_TYPE.actSubscriber) {
                      let first = "Unknown", last = "Unknown";
                      thispost.entity_key = ent.entity_key;
                      ent.first_name = first;
                      ent.last_name = last;
                      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqPerson;
                    }
                    else {
                      thispost.entity_key = ent.entity_key;
                      ent.organization_name = "Unknown";
                      ent.entity_identifier_code = IceTypes.entity_type_qualifier.etqNonPerson;
                    }

                    this.accSvc.postPayment(curDom, curDomType, thispost).subscribe(
                      postdata => {
                        this.searchServices();
                      },
                      posterror => {
                      });
                  }
                }

                let updatedSvcIdx: medicalserviceindex = <medicalserviceindex>foundSvc[0];
                updatedSvcIdx.copyservice(updatedSvc);
                this.updateServiceRecord(updatedSvcIdx, curDomType, curDom);
                this.refreshTableData(datasrc);
              }
            }
          }
        },
        error => {
          console.log(error);
        });
    }

    this.currentCharge = null;
    this.currentBucketChargeList = [];
  }

  onItemCancelClick(event): void {
    this.currentCharge = null;
    this.currentBucketChargeList = [];
  }

  onMatGridRowClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }
  }

  onMatGridRowActionClick(event) {
    if (event["rowData"] == null) {
      // To do log error
      return;
    }

    let appSvc = this.getAppService();
    let typeOfDomain: IceTypes.ACCOUNT_TYPE = IceTypes.ACCOUNT_TYPE.actNone;
    let ctrType: FormControl = this.domainTypeCtrl.getFormControl();
    if (ctrType != null) {
      typeOfDomain = <IceTypes.ACCOUNT_TYPE>ctrType.value;
    }
    let curDom = appSvc.getCurrentAccount(), curDomType = appSvc.getCurrentAccountType();

    if (IceTypes.RecordActionType.oatViewBucket == event.actionItem.value) {
      if (ViewByBucket == this.currentView) {
        let item = <superbillchargesindex>event["rowData"];
        this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + item.superbill_charges_key, false)]);
      }
      else {
        let item2 = <medicalserviceindex>event["rowData"];
        this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let bills: superbillcharges[] = <superbillcharges[]>data;
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/serviceitemcharge/" + bills[0].superbill_charges_key, false)]);
            }
            else { // no bill found
              this.createBucketAndRedirect(curDomType, curDom, item2, true);
            }

          },
          error => {
            console.log(error);
          });
      }
    }
    else if (IceTypes.RecordActionType.oatViewBalance == event.actionItem.value) {
      if (ViewByBucket == this.currentView) {
        let item = <superbillchargesindex>event["rowData"];
        this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + item.superbill_charges_key, false)]);
      }
      else {
        let item2 = <medicalserviceindex>event["rowData"];
        this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let bills: superbillcharges[] = <superbillcharges[]>data;
              this.getRouter().navigate([this.getNavService().buildRoute("accounting/outstandingbalance/" + bills[0].superbill_charges_key, false)]);
            }
            else { // no bill found
              this.createBucketAndRedirect(curDomType, curDom, item2, false);
            }
          },
          error => {
            console.log(error);
          });
      }
    }
    else if (IceTypes.RecordActionType.oatEdit == event.actionItem.value) {
      let item = <superbillchargesindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      if (ViewByService == this.currentView) {
        this.currentCharge = null;
        this.currentChargeCaption = "Edit Service Charge";
        this.currentBucketChargeList = [];
        this.loadTemplateServiceAndInventory(typeOfDomain);

        let item2 = <medicalserviceindex>event["rowData"];
        this.accSvc.getBillByService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key, true).subscribe(
          data => {
            if (data != null && data.length > 0) {
              let bill: superbillcharges = <superbillcharges>data[0];
              if (bill != null) {
                this.loadResponsibleParties(typeOfDomain, bill.to_trans_account, bill.bill_to);
                for (let ichrg = 0; ichrg < bill.CHARGES.length; ichrg++) {
                  let chrgRef: medicalservicereference = <medicalservicereference>bill.CHARGES[ichrg];

                  let foundMedSvc = data.filter(obj => obj.medical_service_key == chrgRef.medical_service_key);
                  if (foundMedSvc.length == 0) continue;
                  if (foundMedSvc[0].medical_service_key == item2.medical_service_key)
                    this.currentCharge = foundMedSvc[0];

                  // Don't show copays
                  if (Iceutility.toLong(foundMedSvc[0].inc_coa_type) != IceTypes.coa_types.coaCoPayIncome)
                    this.currentBucketChargeList.push(foundMedSvc[0]);
                }

                this.initializeCurrentChargePanel(event);
              }
            }
            else {
              this.accSvc.getService(curDom, curDomType, item2.trans_account, typeOfDomain, item2.medical_service_key).subscribe(
                data => {
                  if (data != null && data.length > 0) {
                    let domval = this.domainCtrl.getFormControl().value;
                    let nameOfDom = "";
                    try {
                      let domObj = JSON.parse(domval);
                      if (domObj != null && domObj.length > 0) {
                        nameOfDom = domObj[0].name;
                      }
                    }
                    catch (e) {
                      nameOfDom = "";
                    }
                    this.loadResponsibleParties(typeOfDomain, item2.trans_account, nameOfDom);
                    this.currentCharge = <medicalservice>data[0];
                    this.initializeCurrentChargePanel(event);
                  }
                },
                error => {
                  console.log(error);
                });
            }
          },
          error => {
            console.log(error);
          });
      }
      else {
      }
    }
    else if (IceTypes.RecordActionType.oatRemove == event.actionItem.value) {
      let item = <superbillchargesindex>event["rowData"];
      if (item == null) {
        // To do log error
        return;
      }
      this.accSvc.deleteBill(this.getAppService().getCurrentAccount(), this.getAppService().getCurrentAccountType(), item.superbill_charges_key).subscribe(
        data => {
          let dataSrc = this.getDataSource();
          dataSrc.data = dataSrc.data.filter(b => b.superbill_charges_key != item.superbill_charges_key);
        },
        error => {
          // To do, log error
        });
    }
  }
}
